import { render, staticRenderFns } from "./PresentationViewer.vue?vue&type=template&id=02d7d377&scoped=true"
import script from "./PresentationViewer.vue?vue&type=script&lang=js"
export * from "./PresentationViewer.vue?vue&type=script&lang=js"
import style0 from "./PresentationViewer.vue?vue&type=style&index=0&id=02d7d377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d7d377",
  null
  
)

export default component.exports